import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthService } from '../auth/auth.service';
import { TokenService } from '../token';

@Injectable({
	providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
	constructor(public authService: AuthService, public router: Router, private tokenService: TokenService) {}

	public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.authService.isAuthenticatedObserver().pipe(
			map((authenticated: boolean) => {
				if (authenticated) return true;

				this.authService.logout(state.url);

				return false;
			})
		);
	}
}
